import {
  GET_RECENT_TRANSACTIONS,
  GET_RECENT_TRANSACTIONS_SUCCESS,
  GET_RECENT_TRANSACTIONS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  recentTransactions: {},
};

const getRecentTransactionsReducer = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case GET_RECENT_TRANSACTIONS:
      return { ...state, loading: true };
    case GET_RECENT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        recentTransactions: action?.payload,
        loading: false,
      };
    case GET_RECENT_TRANSACTIONS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getRecentTransactionsReducer;